import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=59edb30e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=59edb30e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59edb30e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59edb30e')) {
      api.createRecord('59edb30e', component.options)
    } else {
      api.reload('59edb30e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=59edb30e&scoped=true&", function () {
      api.rerender('59edb30e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lEcC2vEBvGyG/JS/comp/PopupBox.vue"
export default component.exports